import { Chip } from "@mui/material"
import type { FC } from "react"

import { formatDate } from "@/utils/date"

interface ProductInventoryTransactionDateCellProps {
  date?: string | null
}

export const ProductInventoryTransactionDateCell: FC<ProductInventoryTransactionDateCellProps> = ({ date }) => {
  if (!date) return null

  return <Chip className='h-6 rounded bg-gray-300 text-xs' label={formatDate(date)} />
}
